import { gql } from '@apollo/client'

export const Query = gql`
  query ShowVehicle($companyId: ID!, $filters: VehicleFilters) {
    vehicles(companyId: $companyId, filters: $filters, first: 1) {
      nodes {
        id
        name
        registration
        warehouse {
          id
          name
        }
        productAttachments { 
          id
          url
          filename
        }
        notes
        rateCents
        mileageCents
        payload
        length
        width
        height
        images { 
          id
          url
        }
      }
      pageInfo { startCursor endCursor hasNextPage hasPreviousPage }
    }
  }
`
